import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Wrapper,
  GridContainer,
  LoaderContainer } from './styled';
import Standard from '../strandard-item';
import PulseLoader from '../pulse-loader';
import EmptyState from '../empty-state';

/* eslint-disable */
let toggleStandardCollapse = null;

const Standards = (props) => {
  const { selectedTopics, showGridLoader } = useSelector(state => state.UPFAssignReducer);
  const { learningJourneyIds, handleOnScroll } = props;
  const [isStandardsCollapsed, setIsStandardsCollapsed] = useState(false);
  const [isStandardDirty, setIsStandardDirty] = useState(false);

  toggleStandardCollapse = (collapsedState) => {
    setIsStandardsCollapsed(collapsedState);
    setIsStandardDirty(false);
  }

  if (showGridLoader) {
    return (
      <GridContainer>
        <LoaderContainer>
          <PulseLoader />
        </LoaderContainer>
      </GridContainer>
    );
  }

  if (!learningJourneyIds.length) {
    return (
      <GridContainer>
        <LoaderContainer>
          <EmptyState i18n={props.i18n} />
        </LoaderContainer>
      </GridContainer>
    );
  }

  return (
    <Wrapper id="standards" onScroll={handleOnScroll}>
      {
        selectedTopics.map(topic => (
          topic.childTopics.map((childTopic) => {
            if (!childTopic.selected) return null;

            return (<Standard
              key={childTopic.displayName}
              externalKey={childTopic.externalKey}
              learningJourney={childTopic.childTopics.filter(ct => ct.selected)}
              topicName={childTopic.name}
              description={childTopic.description}
              id={childTopic.id}
              i18n={props.i18n}
              collapseAllStandards={isStandardsCollapsed}
              isStandardDirty= {isStandardDirty}
              setIsStandardDirty={setIsStandardDirty} />);
          })
        ))
      }
    </Wrapper>
  );
};

Standards.propTypes = {
  i18n: PropTypes.object,
  learningJourneyIds: PropTypes.array,
  handleOnScroll: PropTypes.func
};

Standards.defaultProps = {
  learningJourneyIds: [],
  handleOnScroll: () => {}
};

export { Standards, toggleStandardCollapse };
